import React from 'react';
import content from '../../assets/imgs/downModalC.png';

const CdnDownloadContents = ({ isOpen, onClose, children }) => {
  return (
    <div
      style={{ height: '100%', flex: 1, overflow: 'auto', border: 1 }}
      className={'flex-col flex-full gap-16'}
    >
      <div style={{ padding: '0 16px' }}>
        <span
          style={{
            color: '#232323',
            fontFamily: '"Pretendard Variable"',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '140%',
            letterSpacing: '-0.42px',
          }}
        >
          나날이 폭증하는 대용량 컨텐츠를 CDN Server Farm을 통하여 빠르고
          안정적으로 전송하는 서비스입니다. 게임 및 각종 소프트웨어의 설치파일과
          패치파일 등을 사용자가 원하는 프로토콜을 이용하여 전송할 수 있습니다.
        </span>
      </div>
      <img style={{ width: '100%' }} src={content} alt="" />
    </div>
  );
};
CdnDownloadContents.headerTitle = 'DOWNLOAD SERVICE';
export default CdnDownloadContents;
